import React, { useImperativeHandle, useState } from "react";
import {
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
  makeStyles
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import DeleteIcon from "@material-ui/icons/Delete";

const useStyles = makeStyles({
  listItemIcon: {
    minWidth: 42.5
  }
});

const DropdownActionsMenu = (props, ref) => {
  const { onEditClick, onDuplicateClick, onDeleteClick } = props;

  // General
  const classes = useStyles();

  // States
  const [anchorElement, setAnchorElement] = useState(null);
  const [rowData, setRowData] = useState(null);

  // Callbacks
  const handleClose = () => {
    setAnchorElement(null);
  };

  // ImperativeHandle
  useImperativeHandle(ref, () => ({
    open: (data, element) => {
      setRowData(data);
      setAnchorElement(element);
    }
  }));

  return (
    <Menu
      id="simple-menu"
      anchorEl={anchorElement}
      open={Boolean(anchorElement)}
      keepMounted
      onClose={handleClose}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
    >
      {rowData &&
        rowData.status !== "Expired" &&
        rowData.status !== "Completed" && (
          <MenuItem
            onClick={() => {
              handleClose();
              onEditClick(rowData);
            }}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <EditIcon />
            </ListItemIcon>
            <ListItemText>Edit</ListItemText>
          </MenuItem>
        )}
      <MenuItem
        onClick={() => {
          handleClose();
          onDuplicateClick(rowData);
        }}
      >
        <ListItemIcon className={classes.listItemIcon}>
          <FileCopyIcon />
        </ListItemIcon>
        <ListItemText>Duplicate</ListItemText>
      </MenuItem>
      <MenuItem
        onClick={() => {
          handleClose();
          onDeleteClick(rowData);
        }}
      >
        <ListItemIcon className={classes.listItemIcon}>
          <DeleteIcon />
        </ListItemIcon>
        <ListItemText>Delete</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default React.forwardRef(DropdownActionsMenu);
